import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.company.board');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import { ClassicEditor, CKEditorPlugins } from "src/libs/portal/season/ckeditor";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import $ from "jquery";
import moment from "moment";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-company-board',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.company.board/view.scss */
:host {
  display: block;
  height: 100%;
}

::ng-deep .ck-content figure.table {
  margin-left: 0 !important;
  margin-right: auto !important;
  float: none !important;
}
::ng-deep .ck-content table {
  margin-left: 0 !important;
  margin-right: auto !important;
}

.article-content {
  font-size: 15px;
  line-height: 1.8;
  color: #333;
}
.article-content p {
  margin-bottom: 1em;
}
.article-content a {
  color: #2563eb;
  text-decoration: underline;
}
.article-content a:hover {
  color: #1d4ed8;
}
.article-content hr {
  margin: 1.5em 0;
  border-color: #e4e4e7;
}

.iframe-container {
  position: relative;
  background: #fff;
}

.iframe-content {
  height: 80vh;
  min-height: 500px;
  border: none;
}

.ai-messages-area {
  scroll-behavior: smooth;
}

.ai-draft-preview h2 {
  font-size: 14px;
  font-weight: 600;
  margin: 8px 0 4px;
}
.ai-draft-preview h3 {
  font-size: 13px;
  font-weight: 600;
  margin: 6px 0 3px;
}
.ai-draft-preview p {
  margin: 4px 0;
  line-height: 1.6;
}
.ai-draft-preview table {
  width: 100%;
  border-collapse: collapse;
  margin: 6px 0;
  font-size: 11px;
}
.ai-draft-preview table th,
.ai-draft-preview table td {
  border: 1px solid #e4e4e7;
  padding: 3px 6px;
  text-align: left;
}
.ai-draft-preview table th {
  background: #f4f4f5;
  font-weight: 600;
}
.ai-draft-preview ul,
.ai-draft-preview ol {
  padding-left: 16px;
  margin: 4px 0;
}
.ai-draft-preview li {
  margin: 2px 0;
}`],
})
export class PortalLpsysadminWidgetCompanyBoardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }
    @ViewChild('editor')
    public editorElement: ElementRef;
    public post_id: any;
    public comments: any;
    public vote: any;
    public nickname: any;
    public comment_text: any;

    @Input() company: any;
    @Input() category: any;

    public items: any = [];
    public loaded: boolean = false;

    public item: any = {};
    public editor: any;

    public isCrawled: boolean = false;
    public showIframe: boolean = false;
    public iframeUrl: SafeResourceUrl | null = null;
    public iframeLoading: boolean = false;
    public iframeError: boolean = false;
    public generatingDraft: boolean = false;
    public draftYear: string = '';
    public draftQuarter: string = '';
    public draftPrompt: string = '';
    public draftYearOptions: number[] = [];
    public showAiPanel: boolean = false;
    public aiMessages: any[] = [];

    public search: any = {
        page: 1,
        text: "",
    };

    public modeFilter: string = '';

    public async setModeFilter(mode: string) {
        this.modeFilter = mode;
        await this.load(1);
    }

    public async toggleAiPanel() {
        this.showAiPanel = !this.showAiPanel;
        await this.service.render();
    }

    public pagination: any = {
        end: -1,
        start: -1,
    };

    public target_user: any = null;

    public userEvent: any = {
        close: async () => {
            this.target_user = null;
            await this.service.render();
        }
    }

    public async clickUser(user) {
        this.target_user = null;
        await this.service.render();
        this.target_user = user.id;
        await this.service.render();
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership(['admin', 'super_admin'], "/");
        this.search.company_id = this.company.id;
        this.search.category = this.category;
        this.nickname = "관리자";
        const currentYear = new Date().getFullYear();
        for (let y = currentYear; y >= currentYear - 5; y--) {
            this.draftYearOptions.push(y);
        }
        await this.load();
    }

    public async load(page: number = 1) {
        this.search.page = page;
        this.loaded = false;
        this.items = [];
        await this.service.render();
        let body = JSON.parse(JSON.stringify(this.search));
        body.category = this.category;
        if (this.modeFilter) body.mode_filter = this.modeFilter;
        const { code, data } = await wiz.call("search", body);
        if (code != 200) return;
        let { rows, lastpage } = data;
        const startpage = Math.floor((page - 1) / 10) * 10 + 1;
        this.items = rows;
        this.pagination.start = startpage;
        this.pagination.end = lastpage;
        this.loaded = true;
        await this.service.render();
    }

    public async update() {
        this.item.content = this.editor.data.get();
        this.item.company_id = this.company.id;
        let data: any = JSON.stringify(this.item);
        await wiz.call("update", { data: data });
        await this.alert('저장되었습니다', 'Saved', 'success', '확인');

        if (!this.item.id) {
            await this.previous();
            await this.load(this.search.page);
        }
    }

    public async delete() {
        let res: any = await this.alert("정말로 삭제하시겠습니까?", "", "error", "삭제", "취소");
        if (!res) return;
        await wiz.call("delete", { id: this.item.id });
        await this.previous();
        await this.load(this.search.page);
    }

    public async upload() {
        let files = await this.service.file.select();
        if (files.length == 0) return;

        await this.service.loading.show();

        if (!this.item.extra.attachments) this.item.extra.attachments = [];

        for (let i = 0; i < files.length; i++) {
            let fd = new FormData();
            fd.append('upload', files[i]);
            let fdurl = '/file/upload';
            const { url } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });
            this.item.extra.attachments.push({ name: files[i].name, url: url });
        }

        await this.service.loading.hide();
        this.service.render();
    }

    public async removeFile(file) {
        let res: any = await this.alert("정말로 삭제하시겠습니까?", "", "error", "삭제", "취소");
        if (!res) return;
        this.item.extra.attachments.remove(file);
        this.service.render();
    }

    public async alert(message: string, title: any = "", status: any = "error", action: string = '확인', cancel: any = false) {
        return await this.service.alert.show({
            title: title,
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public async generateDraft() {
        if (!this.post_id || this.generatingDraft || this.isCrawled) return;
        if (!this.draftYear) {
            await this.alert('연도를 먼저 선택해주세요.');
            return;
        }
        let requestDesc = `${this.draftYear}년`;
        if (this.draftQuarter) requestDesc += ` ${this.draftQuarter}분기`;
        requestDesc += ' 기업현황 보고서 생성';
        if (this.draftPrompt) requestDesc += `\n요청: ${this.draftPrompt}`;

        this.aiMessages.push({ role: 'user', content: requestDesc });
        const aiMsg: any = { role: 'ai', content: '', error: '', loading: true };
        this.aiMessages.push(aiMsg);

        this.generatingDraft = true;
        await this.service.render();
        this.scrollAiMessages();

        try {
            const { code, data } = await wiz.call('generate_draft', {
                company_id: this.company.id,
                year: this.draftYear,
                quarter: this.draftQuarter || '',
                extra_prompt: this.draftPrompt || ''
            });
            if (code === 200 && data.content) {
                aiMsg.content = data.content;
                aiMsg.loading = false;
            } else {
                aiMsg.loading = false;
                aiMsg.error = data?.message || 'AI 초안 생성에 실패했습니다.';
            }
        } catch (e: any) {
            aiMsg.loading = false;
            aiMsg.error = 'AI 초안 생성 중 오류가 발생했습니다.';
        } finally {
            this.generatingDraft = false;
            this.draftPrompt = '';
            await this.service.render();
            this.scrollAiMessages();
        }
    }

    private scrollAiMessages() {
        setTimeout(() => {
            const el = document.querySelector('.ai-messages-area');
            if (el) el.scrollTop = el.scrollHeight;
        }, 100);
    }

    public async applyDraft(msg: any) {
        if (!this.editor || !msg?.content) return;
        let res = await this.alert('에디터의 기존 내용이 대체됩니다.', '', 'info', '적용', '취소');
        if (!res) return;
        this.editor.data.set(msg.content);
        this.item.content = msg.content;
        msg.applied = true;
        await this.service.render();
    }

    public async select(item) {
        if (item.id != 'new') {
            const { code, data } = await wiz.call("get", { id: item.id });
            if (code != 200) return await this.previous();
            item = data.item;
            this.vote = data.vote;
            this.comments = data.comments;
        }

        this.post_id = item.id;
        this.isCrawled = item.mode === 'crawled';

        if (this.isCrawled) {
            this.item = item;
            this.item.created = moment(item.created).format("YYYY-MM-DD");
            this.showIframe = false;
            this.iframeUrl = null;
            this.iframeError = false;
            await this.service.render();
            return;
        }

        await this.service.render();

        let element: any = this.editorElement.nativeElement;

        if ($(element).parent().find(".ck-content").length == 0) {
            let toolbar = 'heading | bold italic strikethrough underline | blockQuote code | bulletedList numberedList | outdent indent | uploadImage insertTable link codeBlock horizontalLine | specialCharacters'.split(' ');

            this.editor = await ClassicEditor.create(element, {
                toolbar: {
                    items: toolbar,
                    shouldNotGroupWhenFull: true
                },
                removePlugins: ["MediaEmbedToolbar", "Autoformat"],
                plugins: CKEditorPlugins,
                simpleUpload: {
                    uploadUrl: '/file/upload'
                },
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableCellProperties', 'tableProperties']
                },
                list: {
                    properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true
                    }
                }
            });
        }

        if (item.id == 'new') {
            this.item = {
                category: this.category,
                fund_id: this.company.id,
                title: '',
                content: '',
                level: '일반',
                status: 'publish',
                mode: '일반',
                extra: {},
                created: moment().format("YYYY-MM-DD")
            };
        } else {
            this.item = item;
            if (!this.item.level) item.level = '일반';
            this.item.created = moment(item.created).format("YYYY-MM-DD");
        }

        console.log(this.item);
        this.editor.data.set(this.item.content);

        if (!this.item.extra.vote) this.item.extra.vote = [];

        await this.service.render();
    }

    public async previous() {
        this.post_id = null;
        this.vote = null;
        this.comments = null;
        this.item = {};
        this.isCrawled = false;
        this.showIframe = false;
        this.iframeUrl = null;
        this.iframeError = false;
        await this.service.render();
    }

    public openOriginal() {
        if (this.item.extra && this.item.extra.source_url) {
            window.open(this.item.extra.source_url, '_blank');
        }
    }

    public async toggleIframe() {
        if (this.showIframe) {
            this.showIframe = false;
            this.iframeUrl = null;
            this.iframeError = false;
            await this.service.render();
            return;
        }

        if (this.item.extra && this.item.extra.source_url) {
            this.iframeLoading = true;
            this.iframeError = false;
            this.showIframe = true;
            this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.item.extra.source_url);
            await this.service.render();
        }
    }

    public onIframeLoad() {
        this.iframeLoading = false;
        this.service.render();
    }

    public onIframeError() {
        this.iframeLoading = false;
        this.iframeError = true;
        this.service.render();
    }

    public async actionVote() {
        if (!this.post_id) return;
        await wiz.call("vote", { board_id: this.post_id, vote: this.vote, nickname: this.nickname });
        await this.select(this.item);
    }

    public async sendComment() {
        if (!this.comment_text) return;
        await wiz.call("comment", { board_id: this.post_id, text: this.comment_text, nickname: this.nickname });
        this.comment_text = null;
        await this.select(this.item);
    }

    public async removeComment(comment) {
        let res = await this.service.alert.error("댓글을 삭제하시겠습니까?", "닫기", "삭제");
        if (!res) return;
        await wiz.call("remove_comment", comment);
        await this.select(this.item);
    }

    public async toggleVote() {
        let res = true;
        if (this.item.extra.vote_end) res = await this.service.alert.error("투표를 재개하시겠습니까?", "닫기", "재개");
        else res = await this.service.alert.error("투표를 종료하시겠습니까?", "닫기", "종료");
        if (!res) return;
        this.item.extra.vote_end = !this.item.extra.vote_end;
        await this.service.render();
        await this.update();
    }

}

export default PortalLpsysadminWidgetCompanyBoardComponent;